var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCrown(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 36,
    viewBox: "0 0 37 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "hugeicons:crown"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M18.6664 21H18.6799M11.1664 33H26.1664M5.94335 15.459C5.36135 13.848 5.07035 13.0425 5.19335 12.5265C5.32985 11.961 5.73185 11.5215 6.24485 11.3745C6.71435 11.2395 7.44485 11.565 8.90435 12.2145C10.1944 12.7875 10.8394 13.074 11.4469 13.059C12.1159 13.041 12.7579 12.774 13.2694 12.2985C13.7344 11.868 14.0449 11.1825 14.6674 9.8115L16.0399 6.7875C17.1859 4.263 17.7589 3 18.6664 3C19.5739 3 20.1469 4.263 21.2929 6.7875L22.6654 9.8115C23.2879 11.1825 23.5999 11.868 24.0634 12.2985C24.5749 12.7725 25.2184 13.041 25.8859 13.059C26.4919 13.074 27.1384 12.7875 28.4284 12.213C29.8894 11.565 30.6184 11.2395 31.0879 11.3745C31.6009 11.5215 32.0029 11.961 32.1379 12.5265C32.2624 13.0425 31.9714 13.8465 31.3879 15.459L28.8874 22.383C27.8164 25.3455 27.2824 26.826 26.1619 27.663C25.0414 28.5 23.5939 28.5 20.7004 28.5H16.6324C13.7374 28.5 12.2914 28.5 11.1724 27.663C10.0519 26.826 9.51635 25.3455 8.44535 22.383L5.94335 15.459Z",
    stroke: "#038CEF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrown);
export default __webpack_public_path__ + "static/media/crown.a7a437ea7783c4cfd452a31b7276786b.svg";
export { ForwardRef as ReactComponent };